import styled from 'styled-components'
import { white } from 'tcp-common/lib/colors'

export const AccordianHeading = styled.span`
font-weight: 400;
font-size: 24px;
line-height: 32px;
color: ${white};
@media (max-width: 768px) {
    font-weight: 400;
    font-size: 20px;
    line-height: 24px;
}
`
